import React from 'react';
import MainContainer from "../../UI/MainContainer";
import Header from "../../Layouts/Header/Header";
import SubMainContainer from "../../UI/SubMainContainer";
import SideBar from "../../Layouts/SideBar/SideBar";
import PromosData from "../../Settings/Promos/PromosData";

function Promos(props) {
    return (
        <>
            {/*<div id="portal-root"></div>*/}
            <MainContainer>
                <Header />
                <SubMainContainer>
                    <SideBar />
                    <div className="rightCol">
                        <PromosData/>
                    </div>
                </SubMainContainer>
            </MainContainer>
        </>
    );
}

export default Promos;